<template>
  <progress
    v-bind="$attrs"
    v-if="value"
    class="progress is-tiny is-primary mb-0" max="100">
  </progress>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/progress.scss';
</style>